import React from "react";
import { useSelector } from "react-redux";
import { Container, Row, Col } from "reactstrap";
import BootstrapTable from "react-bootstrap-table-next";
import filterFactory from "react-bootstrap-table2-filter";
import paginationFactory, {
  PaginationProvider,
  PaginationListStandalone,
} from "react-bootstrap-table2-paginator";
import "react-bootstrap-table2-filter/dist/react-bootstrap-table2-filter.min.css";

import { formatDateManager } from "managers/formatDateManager";
import { staticData } from "managers/staticDataManager";
import { dataManager } from "managers/data/dataManager";

import { DEFAULT_LIST_PAGESIZE } from "config";
import { useNavigateUrl } from "managers/utilManager";

const PublicTable = (params) => {
  const state = useSelector((state) => state);

  const headerStyle = {
    backgroundColor: process.env.REACT_APP_BRAND_COLOR || "#f5593d",
    color: "white",
  };

  const publishedDateStyle = {
    whiteSpace: "nowrap",
  };

  const customizeFilterLayoutData = (cell) => {
    if (!cell) return "";
    return cell.description;
  };

  const customizePublishedDateData = (cell) => {
    if (!cell) return "";
    return formatDateManager.formatStandardWithTime(cell);
  };

  const handleTableChange = (type, { page, sortField, sortOrder }) => {
    const sortingField = columns.find(
      (col) => col.dataField === sortField
    )?.sortField;

    if (type === "sort") {
      params.setFilterData({
        ...params.filterData,
        page: 1,
        sortField: sortingField,
        sortOrder: sortOrder,
      });
    }

    if (type === "pagination") {
      params.setFilterData({
        ...params.filterData,
        page: page,
      });
    }
  };

  const navigateUrl = useNavigateUrl();

  const issuerCellClickHandler = (e, cell, rowIndex, row) => {
    if (row?.issuerId) {
      navigateUrl(`/search/${row.issuerId}`);
    }
  };

  const layoutCellClickHandler = (e, cell, rowIndex, row) => {
    navigateUrl(`/document/${row?.documentId}`);
  };

  const cellMouseEnterHandler = (e) => {
    e.target.style.textDecoration = "underline";
    e.target.style.cursor = "pointer";
  };

  const cellMouseLeaveHandler = (e) => {
    e.target.style.textDecoration = "";
    e.target.style.cursor = "default";
  };

  const columns = [
    {
      dataField: "issuer",
      sortField: "il.displayName",
      text: staticData.loadTerms(useSelector, "VW_FILTER_ISSUER"),
      sort: true,
      formatter: (cell, row) => dataManager.getIssuerDisplayName(state, cell),
      events: {
        onClick: issuerCellClickHandler,
        onMouseEnter: cellMouseEnterHandler,
        onMouseLeave: cellMouseLeaveHandler,
      },
      headerStyle: headerStyle,
    },
    {
      dataField: "layout",
      sortField: "layout.Description",
      text: staticData.loadTerms(useSelector, "VW_FILTER_LAYOUT"),
      sort: true,
      formatter: (cell, row) => customizeFilterLayoutData(cell),
      events: {
        onClick: layoutCellClickHandler,
        onMouseEnter: cellMouseEnterHandler,
        onMouseLeave: cellMouseLeaveHandler,
      },
      headerStyle: headerStyle,
    },
    {
      dataField: "publishedDate",
      sortField: "doc.publishedDate",
      text: staticData.loadTerms(useSelector, "VW_FILTER_PUBLISHEDDATE"),
      sort: true,
      formatter: (cell, row) => customizePublishedDateData(cell),
      headerStyle: headerStyle,
      style: publishedDateStyle,
    },
  ];

  const options = {
    custom: true,
    page: params.filterData?.page ?? 1,
    sizePerPage: DEFAULT_LIST_PAGESIZE,
    sizePerPageList: [],
    totalSize: params?.documentsData?.totalSize,
  };

  return (
    <Container className="mt-3">
      <Row>
        <Col sm="12" md="12">
          <PaginationProvider pagination={paginationFactory(options)}>
            {({ paginationProps, paginationTableProps }) => (
              <div className="public-table-pagionator-wrapper">
                <BootstrapTable
                  remote
                  hover
                  bootstrap4
                  keyField="documentId"
                  columns={columns}
                  data={params?.documentsData?.data}
                  onTableChange={handleTableChange}
                  filter={filterFactory()}
                  bordered={false}
                  {...paginationTableProps}
                />
                <PaginationListStandalone {...paginationProps} />
              </div>
            )}
          </PaginationProvider>
        </Col>
      </Row>
    </Container>
  );
};

export default PublicTable;
